import clsx from 'clsx';

import styles from './Skeleton.module.scss';

type SkeletonProps = {
  className?: string;
  rows?: number;
};

export const Skeleton = ({ className, rows = 5 }: SkeletonProps) => (
  <div className={clsx(styles.skeleton, className)}>
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className={styles['skeleton-line']} />
    ))}
  </div>
);
